import { Type, type Static } from '@sinclair/typebox';
import {
  defineSchema,
  SystemFields,
  StringField,
  TextField,
  BooleanField,
  IntegerField,
} from '@ayocore/platform/common/helpers/schema-types';

import { name as moduleName } from '../module.json';
/**
 * Справочник источников лидов (каналы входящих заявок).
 *
 * Универсальный справочник CRM — используется всеми клиентами.
 * Конкретные значения регистрируются из клиентских модулей через defineLeadSource().
 */
export const LeadSourceSchema = Type.Object({
  ...SystemFields,

  code: StringField({
    title: 'Код источника',
    minLength: 1,
    maxLength: 100,
    description: 'Уникальный код источника (WEBSITE, PHONE, EMAIL и т.д.)',
  }),

  name: StringField({
    title: 'Название источника',
    minLength: 1,
    maxLength: 255,
    description: 'Человекочитаемое название источника лида.',
  }),

  description: TextField({
    title: 'Описание',
    nullable: true,
    description: 'Дополнительное описание источника.',
  }),

  sort_order: IntegerField({
    title: 'Порядок сортировки',
    default: 0,
    description: 'Порядок отображения в списке.',
  }),

  is_active: BooleanField({
    title: 'Активен',
    default: true,
    description: 'Доступен для выбора при создании лида.',
  }),
});

export type LeadSource = Static<typeof LeadSourceSchema>;

export default defineSchema({
  moduleName,
  tableName: 'lead_sources',
  schema: LeadSourceSchema,
  additionalIndexes: [{ columns: ['code'], unique: true }, 'is_active', 'sort_order'],
  dependencies: [],
});
